export enum Page {
  Home = 'home',
  SRP = 'srp',
  VIP = 'vip',
}
